/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Phone/Phones/Content/Phone/Description"
  
}) {
let phoneDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'phone',
path: 'description',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 flexBasis={1}
 flexGrow={1}
 data="phone.description"
 text={phoneDescriptionValueData}
/>
{children}
</React.Fragment>)
}